import { Collapse, Space } from 'antd'
import CollapsePanel from 'antd/lib/collapse/CollapsePanel'
import { Permission, alphabeticalSort } from 'shared'
import { CIMSTags } from 'components/CIMSTags'
import { PermissionViewerProps } from './types'

/**
 * use CIMSCollapse instead of Collapse
 *
 * @expires 2024-06-01
 */
const PermissionViewer: React.FC<PermissionViewerProps> = ({
  additionalPermissionIds,
  roles,
}) => {
  if (!additionalPermissionIds?.length && !roles?.length) return null
  const allPermissionIds = [
    ...new Set([
      ...(additionalPermissionIds ?? []),
      ...(roles
        ?.filter(({ permissions }) => permissions)
        .flatMap(({ permissions }) => permissions) ?? []),
    ]),
  ]
  const allPermissionsMap = Permission.moduleToPageToBasics
  return (
    <Collapse>
      {[...allPermissionsMap.keys()]
        .filter((moduleItem) =>
          Permission.findByModule(moduleItem)
            .map(({ id }) => id)
            .some((id) => allPermissionIds.includes(id))
        )
        .sort(alphabeticalSort('name'))
        .map((moduleItem) => {
          return (
            <CollapsePanel key={moduleItem.id} header={moduleItem.name}>
              <Space size="large" direction="vertical">
                {[...allPermissionsMap.get(moduleItem)!.entries()]
                  .filter(([_, pagePermissions]) =>
                    pagePermissions
                      .map(({ id }) => id)
                      .some((id) => allPermissionIds.includes(id))
                  )
                  .map(([pageItem, pagePermissions]) => (
                    <Space key={pageItem.id} direction="vertical" size="small">
                      {`${pageItem.name}: `}
                      <CIMSTags
                        tags={pagePermissions
                          .filter(({ id }) => allPermissionIds.includes(id))
                          .map(({ id, name, description }) => ({
                            key: id,
                            text: name,
                            color:
                              roles && additionalPermissionIds?.includes(id)
                                ? 'blue'
                                : undefined,
                            tooltip: description,
                          }))}
                      />
                    </Space>
                  ))}
              </Space>
            </CollapsePanel>
          )
        })}
    </Collapse>
  )
}

export default PermissionViewer
